module.exports = __webpack_public_path__ + "static/img/imgs3.ca05746e.jpg";